(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adem-carta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adem-carta')) {
    class AdemCarta extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && window.Shopify.designMode) return;
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.classList.add('is-animated');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              this.observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        );
        this.querySelectorAll('[data-reveal]').forEach((el) => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('adem-carta', AdemCarta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adem-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adem-reels')) {
    class AdemReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-reel]'));
        if (!this.track || !this.cards.length) return;

        this.active = -1;
        this.dragged = false;

        this.cards.forEach((card, index) => {
          const video = card.querySelector('video');
          if (video) {
            video.removeAttribute('controls');
            video.setAttribute('playsinline', '');
            video.playsInline = true;
            video.loop = true;
            const bar = card.querySelector('[data-progress]');
            video.addEventListener('timeupdate', () => {
              if (bar && video.duration) bar.style.transform = `scaleX(${video.currentTime / video.duration})`;
            });
            video.addEventListener('play', () => {
              card.classList.add('is-playing');
              card.classList.remove('is-paused');
            });
            video.addEventListener('pause', () => {
              card.classList.remove('is-playing');
              if (video.currentTime > 0) card.classList.add('is-paused');
            });
          }

          card.addEventListener('click', () => {
            if (this.dragged) return;
            if (index !== this.active) {
              this.goTo(index);
              return;
            }
            this.toggle(card);
          });
        });

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.active - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.active + 1));

        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.updateActive());
          },
          { passive: true }
        );
        this.track.addEventListener('scrollend', () => this.updateActive());

        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));

        this.visibility = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) this.pauseAll();
          });
        });
        this.visibility.observe(this);

        this.onBlockSelect = (event) => {
          const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
          if (index > -1) this.goTo(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        const start = this.cards.length >= 3 ? 1 : 0;
        requestAnimationFrame(() => {
          this.goTo(start, 'instant');
          this.updateActive();
        });
      }

      disconnectedCallback() {
        this.visibility?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      targetLeft(card) {
        return card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
      }

      goTo(index, behavior = 'smooth') {
        const clamped = Math.max(0, Math.min(this.cards.length - 1, index));
        if (clamped !== this.active) this.pauseAll();
        this.track.scrollTo({ left: this.targetLeft(this.cards[clamped]), behavior });
      }

      updateActive() {
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let nearest = 0;
        let best = Infinity;
        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
          if (distance < best) {
            best = distance;
            nearest = index;
          }
        });
        if (nearest === this.active) return;
        this.pauseAll();
        this.cards.forEach((card, index) => card.classList.toggle('is-active', index === nearest));
        this.active = nearest;
      }

      toggle(card) {
        const video = card.querySelector('video');
        if (!video) return;
        if (video.paused) {
          this.pauseAll(video);
          video.muted = false;
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        } else {
          video.pause();
        }
      }

      pauseAll(except) {
        this.cards.forEach((card) => {
          const video = card.querySelector('video');
          if (video && video !== except && !video.paused) video.pause();
        });
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        const startX = event.clientX;
        const startScroll = this.track.scrollLeft;
        this.dragged = false;

        const onMove = (moveEvent) => {
          const delta = moveEvent.clientX - startX;
          if (Math.abs(delta) > 5) {
            this.dragged = true;
            this.track.classList.add('is-dragging');
          }
          if (this.dragged) this.track.scrollLeft = startScroll - delta;
        };

        const onUp = () => {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
          if (this.dragged) {
            this.track.classList.remove('is-dragging');
            this.updateActive();
            this.goTo(this.active);
            setTimeout(() => {
              this.dragged = false;
            }, 50);
          }
        };

        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
      }
    }

    customElements.define('adem-reels', AdemReels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
